import { WalletType } from "@wallet-manager/node-types/dist/src/postgres/const";
import AddressBookSuggestion from "src/components/AddressBookSuggestion";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import { FilterFieldsKeys } from "src/views/WalletManagement/WalletBalanceMonitor/types/FilterFields";

export type AddressBookFields = {
  to_address: string;
  amount: string;
  display_name: string;
  wallet_type: string;
  to_wallet_tag: string;
};

function WalletAddressTextField({
  chainName,
  addressBookFields,
  onChange,
}: {
  chainName: string;
  addressBookFields: AddressBookFields;
  onChange: (key: keyof AddressBookFields, value: string) => void;
}) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t, tc } = useTranslation(translatePrefix);
  return (
    <AddressBookSuggestion
      item={addressBookFields}
      isAllowFreeInput={false}
      walletTypes={[String(WalletType.HotWallet)]}
      chain_name={chainName}
      setField={onChange}
      config={{
        label: tc("phSelection", {
          fieldName: t(FilterFieldsKeys.WalletAddress),
        }),
      }}
    />
  );
}

export default WalletAddressTextField;
